import { render, staticRenderFns } from "./RecordSectionSettings.vue?vue&type=template&id=4c708f5c&scoped=true"
import script from "./RecordSectionSettings.vue?vue&type=script&lang=ts"
export * from "./RecordSectionSettings.vue?vue&type=script&lang=ts"
import style0 from "./RecordSectionSettings.vue?vue&type=style&index=0&id=4c708f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c708f5c",
  null
  
)

export default component.exports